import { ControlsBackdrop } from "../../../ui/controls/backdrop.js";
import { ControlsContent } from "../../../ui/controls/content.js";
import { ControlsGroup } from "../../../ui/controls/group.js";
import { ControlsRoot } from "../../../ui/controls/root.js";
import { TooltipProvider } from "../../../ui/tooltip/provider.js";
import { ButtonTooltip } from "../shared/components/buttons/button-tooltip.js";
import { LiveButton } from "../shared/components/buttons/live-button.js";
import { AirPlayButton } from "./components/buttons/airplay-button.js";
import { CastButton } from "./components/buttons/cast-button.js";
import { FullscreenButton } from "./components/buttons/fullscreen-button.js";
import { PiPButton } from "./components/buttons/pip-button.js";
import { PlayButton } from "./components/buttons/play-button.js";
import { VolumePopover } from "./components/controls/volume-popover.js";
import { CaptionsMenu } from "./components/menus/captions-menu.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/default-live-video/controls.tsx
/** @jsxImportSource react */
function DefaultLiveVideoControls() {
	return /* @__PURE__ */ jsxs(ControlsRoot, { children: [/* @__PURE__ */ jsx(ControlsBackdrop, { className: "video-controls-backdrop" }), /* @__PURE__ */ jsx(ControlsContent, {
		className: cn("video-controls", "video-controls-content", "video-controls-spaced"),
		children: /* @__PURE__ */ jsx(TooltipProvider, { children: /* @__PURE__ */ jsxs(ControlsGroup, {
			className: cn("video-controls-primary", "video-controls-spaced"),
			children: [
				/* @__PURE__ */ jsx(ButtonTooltip, {
					side: "top",
					children: /* @__PURE__ */ jsx(PlayButton, {})
				}),
				/* @__PURE__ */ jsx(LiveButton, {}),
				/* @__PURE__ */ jsx("div", {
					"aria-hidden": "true",
					className: "video-controls-spacer"
				}),
				/* @__PURE__ */ jsx(VolumePopover, {}),
				/* @__PURE__ */ jsx(CaptionsMenu, { className: "video-controls-captions-menu" }),
				/* @__PURE__ */ jsx(ButtonTooltip, {
					side: "top",
					children: /* @__PURE__ */ jsx(CastButton, {})
				}),
				/* @__PURE__ */ jsx(ButtonTooltip, {
					side: "top",
					children: /* @__PURE__ */ jsx(AirPlayButton, {})
				}),
				/* @__PURE__ */ jsx(ButtonTooltip, {
					side: "top",
					children: /* @__PURE__ */ jsx(PiPButton, {})
				}),
				/* @__PURE__ */ jsx(ButtonTooltip, {
					side: "top",
					children: /* @__PURE__ */ jsx(FullscreenButton, {})
				})
			]
		}) })
	})] });
}
//#endregion
export { DefaultLiveVideoControls };

//# sourceMappingURL=controls.js.map